import React from 'react';
import { Card } from '@/components/ui/card';

const About = () => {
  return (
    <div className="pt-20" data-testid="about-page">
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="order-2 md:order-1">
              <img
                src="https://customer-assets.emergentagent.com/job_mindful-sessions-13/artifacts/uys3000n_WhatsApp%20Image%202026-03-24%20at%2012.24.34.jpeg"
                alt="Anvita Sethi - Integrative Psychotherapist"
                className="rounded-3xl shadow-2xl w-full h-[700px] object-cover object-top"
                data-testid="therapist-image"
              />
            </div>
            <div className="order-1 md:order-2 space-y-8">
              <div>
                <p className="text-accent font-medium text-lg mb-2">About Me</p>
                <h1 className="text-5xl md:text-6xl font-heading font-light tracking-tight text-foreground mb-6" data-testid="about-heading">
                  Meet <span className="italic text-primary">Anvita</span>
                </h1>
              </div>
              
              <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
                <p>
                  Hey, I'm Anvita! I help people untangle their thoughts, make sense of their emotions, and navigate relationships with more clarity and compassion.
                </p>
                <p>
                  With over a decade of experience, I've worked with adolescents, individuals, and couples across different life stages. Whether you're dealing with anxiety, healing from trauma, navigating a relationship challenge, or simply feeling stuck, I'm here to walk alongside you.
                </p>
                <p>
                  Therapy with me is a mix of deep conversations, thoughtful insights, and a little bit of humor—because healing doesn't have to be heavy all the time. I believe in creating a non-judgmental space where you can be authentically yourself.
                </p>
                <p>
                  My approach is integrative, drawing from modalities like Internal Family Systems, Somatic Practices, Cognitive Behavioral Therapy, Psychodynamic Therapy, Gestalt, and Expressive Arts Therapy to tailor our sessions to what works best for you. I am trauma-informed, queer-friendly, neurodivergence-positive, and caste-affirmative.
                </p>
                <p>
                  I'm also the co-founder of <strong>UNTAMED</strong>—a body image community for women, supporting individuals in building healthier relationships with their bodies.
                </p>
              </div>

              <Card className="bg-secondary/50 backdrop-blur-sm border-none rounded-2xl p-8 space-y-6">
                <div>
                  <h3 className="text-2xl font-heading font-medium text-foreground mb-4">Education & Training</h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li className="flex items-start">
                      <span className="text-primary mr-3 text-xl">•</span>
                      <span>Master of Science in Clinical Psychology, Christ University, Bengaluru</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary mr-3 text-xl">•</span>
                      <span>Bachelor of Arts in Applied Psychology, University of Delhi</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary mr-3 text-xl">•</span>
                      <span>Bachelor of Arts in Social Work, Indira Gandhi National Open University</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-2xl font-heading font-medium text-foreground mb-4">Certifications</h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li className="flex items-start">
                      <span className="text-primary mr-3 text-xl">•</span>
                      <span>Gottman's Couples Therapy (Ongoing)</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary mr-3 text-xl">•</span>
                      <span>Trauma-Focused Therapy — Dr. Shalini Anant</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary mr-3 text-xl">•</span>
                      <span>Dialectical Behaviour Therapy — Dr. Elmira Strange</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary mr-3 text-xl">•</span>
                      <span>Transformational Systemic Therapy — Dr. Linda Lucas</span>
                    </li>
                  </ul>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 bg-secondary/30">
        <div className="max-w-5xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl font-heading font-normal text-foreground">
            Professional Background
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 text-center">
              <div className="text-4xl font-heading font-bold text-primary mb-4">10+</div>
              <p className="text-muted-foreground">Years of Experience</p>
            </Card>
            <Card className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 text-center">
              <div className="text-4xl font-heading font-bold text-primary mb-4">700+</div>
              <p className="text-muted-foreground">Clients Supported</p>
            </Card>
            <Card className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 text-center">
              <div className="text-4xl font-heading font-bold text-primary mb-4">6,000+</div>
              <p className="text-muted-foreground">Client Hours</p>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
